import {call, put, takeLatest} from 'redux-saga/effects';
import ApiUtil from "src/utils/ApiUtil";
import {
    BULK_PRODUCTS_QUERY_START, BulkProductsReportQueryStartAction,
    getBulkProductsQueryFailedAction,
    getBulkProductsQuerySuccessAction
} from "src/actions/BulkReportQueryAction";
import {ProductInfo, ProgramInput} from "src/model/ProductMatch";
import {CommonInput, FeeEstimateRequest, MFNProgramInput, NonMFNProgramInput, ProgramParam} from "src/model/BulkReport";
import QueryProductInfo from "src/model/QueryProduct";
import {getCurrencyUnitConfig, PROGRAM_NAME_OF_MFN} from "src/config/Config";
import MetricsUtil from "src/utils/MetricsUtil";


export function* getBulkProductReport(action: BulkProductsReportQueryStartAction) {
    try {
        const parameters = {"feeEstimationRequestList": buildRequest(action.products, action.countryCode)};
        // @ts-ignore
        const response = yield call(ApiUtil.postApiWithTimeout, "getbatchfees", parameters);
        let metricsUtil = MetricsUtil.getMetricsUtil();
        if (metricsUtil) {
            metricsUtil.publishCounter("getbatchfees", "bulkSize", action.products.length);
        }
        if (response.succeed) {
            yield put(getBulkProductsQuerySuccessAction(response.data));
        } else {
            yield put(getBulkProductsQueryFailedAction());
        }
    } catch (error) {
        console.error("Call API getbatchfees error" + error)
        yield put(getBulkProductsQueryFailedAction());
        return;
    }
}

const buildRequest = (products: Array<ProductInfo>, countryCode: string) => {
    let feeEstimateRequests: Array<FeeEstimateRequest> = [];
    products.forEach(product => {
        let programList: Array<string> = [];
        let programParamMap: Record<string, ProgramParam> = {};
        const inputMap = product.programInputMap as Map<string, ProgramInput>;
        inputMap.forEach((programInput, program) => {
            programList.push(program);
            programParamMap = {...programParamMap, [program]: buildProgramParam(program, programInput, countryCode)};
        })
        const feeEstimateRequest: FeeEstimateRequest = {
            countryCode: countryCode,
            itemInfo: productInfoToQueryProduct(product, countryCode),
            programIdList: programList,
            programParamMap: programParamMap,
            isNonPeakSelected: product.isNonPeakSelected ?? true
        };
        feeEstimateRequests.push(feeEstimateRequest);
    })

    return feeEstimateRequests;
}

const buildProgramParam = (program: string, programInput: ProgramInput, countryCode: string) => {
    const commonInput: CommonInput = {
        averageInventoryUnitsStored: programInput.averageInventoryUnitsStored ?? 1,
        costOfGoodsSold: programInput.costOfGoodsSold ?? 0,
        estimatedMonthlyUnitsSold: programInput.estimatedMonthlyUnitsSold ?? 1,
        estimatesSales: programInput.estimatedSales ?? 1,
        miscellaneousCost: programInput.miscellaneousCost ?? 0
    }
    const mfnProgramInput: MFNProgramInput = {
        fulfillmentCost: programInput.fulfillCost ?? 0,
        monthlyStorageFeePerUnit: programInput.monthlyStorageCostPerUnit ?? 0,
        shippingCharge: programInput.shippingCharge ?? 0
    }
    const nonMFNProgramInput: NonMFNProgramInput = {
        isBubblewrapChosen: programInput.isBubbleWrap ?? false,
        isFBAInboundConvenienceChosen: programInput.isPlacement ?? false,
        isLabelingChosen: programInput.isLabel ?? false,
        isOpaqueBaggingChosen: programInput.isOpaqueBagging ?? false,
        isPolybaggingChosen: programInput.isBagging ?? false,
        isTapingChosen: programInput.isTape ?? false,
        shippingToAmazon: programInput.sendToAmazon ?? 0
    }
    let programParam: ProgramParam = {
        inventoryPlace: programInput.inventoryPlace ?? countryCode,
        marketplace: programInput.marketplace ?? countryCode,
        commonInput: commonInput,
    }
    programParam = program == PROGRAM_NAME_OF_MFN ?
        {
            ...programParam,
            mfnProgramInput: mfnProgramInput
        } : {
            ...programParam,
            nonMFNProgramInput: nonMFNProgramInput
        };
    return programParam;
}

const productInfoToQueryProduct = (product: ProductInfo, countryCode: string) => {
    let queryProduct: QueryProductInfo = {
        asin: product.asin,
        merchantSku: product.merchantSku,
        fnsku: product.fnsku,
        glProductGroupName: product.gl,
        tRexId: product.tRexId,
        specialDeliveryRequirement: product.specialDeliveryRequirement,
        title: product.title,
        packageLength: product.length + '',
        packageWidth: product.width + '',
        packageHeight: product.height + '',
        dimensionUnit: product.dimensionUnit!,
        packageWeight: product.weight + '',
        weightUnit: product.weightUnit!,
        afnPriceStr: product.price + '',// User can update them in program component
        mfnPriceStr: product.price + '',
        mfnShippingPriceStr: '0',//TODO:get shipping from MYI
        currency: product.currency ? product.currency : getCurrencyUnitConfig(countryCode),
        isNewDefined: false,
    };
    return queryProduct;
}

export default function* bulkProductReport() {
    yield takeLatest([BULK_PRODUCTS_QUERY_START], getBulkProductReport);
}
